import NextButton from '../NextButton';
import styles from '../../assets/css/accounts.module.css';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_SELECTION_PREFIX } from '../../utils/translationPagePrefix';

const NoAccountsMessage = () => {
	const { t } = useTranslation();
	const noAccountsMessage = t(`${ACCOUNT_SELECTION_PREFIX}.no-accounts`);
	const pleaseSelectMessage = t(`${ACCOUNT_SELECTION_PREFIX}.please-try-select`);
	const chooseDifferentBankMessage = t(`${ACCOUNT_SELECTION_PREFIX}.choose-different-bank`);

	return (
		<div className={styles['no-accounts-message-div']}>
			<span>{noAccountsMessage}</span>
			<br />
			<span>{pleaseSelectMessage}</span>
			<NextButton
				text={chooseDifferentBankMessage}
				onClick={() => {
					window.location.reload();
				}}
				disabled={false}
			/>
		</div>
	);
};

export default NoAccountsMessage;
